import { Grid } from '@mui/material';
import EAAccordion from '../../../EAAccordion';
import React, { useCallback, useContext, useEffect } from 'react';
import useStyles from "../../../../style/js-style/containers/thirdparties/sheet/TPSheetStyle.js";
import DocumentsDataTable from '../../../documents/DocumentsDataTable';
import i18next from 'i18next';
import EAButton from 'components/common/EAButton';
import EAIcon from 'components/common/EAIcon';
import { downloadThirdpartyDocuments } from 'services/edge/ThirdpartyService';
import { Context } from 'states/Store';
import { ERROR } from 'services/common/Constants';

const DocumentSection = ({ display,
                           title,
                           tpVisibleDocsCount,
                           thirdpartyDocuments,
                           setTpVisibleDocsCount,
                           answerCount,
                           sortModel,
                           setSortModel,
                           thirdparty
                          }) => {
  const { classes } = useStyles();
  const [isExpanded, setExpanded] = React.useState(true);

  useEffect(() => {
    setExpanded(thirdpartyDocuments?.length);
  }, [thirdpartyDocuments]);

  const [state, dispatch] = useContext(Context);

  const fetchAndDownloadThirdpartyDocuments = useCallback(() => {
    async function downloadTpDocuments() {
      try {
        const result = await downloadThirdpartyDocuments(
          state.account.id,
          thirdparty?.thirdpartyId
        );
        window.open(
          result.content,
          "_blank",
          "noopener, noreferrer"
        );
      } catch (error) {
        dispatch({
          type: "ALERT",
          alert: { type: ERROR, msg: "DOWNLOAD_DOCS_ERROR" },
        });
      }
    }

    if (state.account) {
      downloadTpDocuments();
    }
  }, [dispatch, state.account, thirdparty]);

  return display && (
    <Grid item xs={12} className={classes.tpItem} id={"documents"}>
      <EAAccordion
        title={title}
        logo="document"
        counter={
          tpVisibleDocsCount !== null
            ? tpVisibleDocsCount
            : thirdpartyDocuments?.length
        }
        totalCount={thirdpartyDocuments?.length}
        buttons={[
          <div>
              <EAButton
              onClick={() => fetchAndDownloadThirdpartyDocuments()}
              size="xs"
              content={
                <>
                  {<EAIcon icon={"download"}/>}
                  {i18next.t('download')}
                </>
              }
            />
          </div>
        ]}
        opened={isExpanded}
      >
        <DocumentsDataTable
          documents={thirdpartyDocuments}
          component="thirdparty"
          pageSize={10}
          sortModel={sortModel}
          onSortModelChange={setSortModel}
          multiDataGridPage
          sheetVariant={true}
          onVisibleRowsCountChange={(count) =>
            setTpVisibleDocsCount(count)
          }
          answerCount={answerCount}
        />
      </EAAccordion>
    </Grid>
  );
};

export default DocumentSection;
